import { createReducer, on } from "@ngrx/store";
import { CartLineItemMiniDetails } from "../../market-place/model/wallet/CartLineItemMiniDetails";
import { remove_item_from_mini_cart_action, set_mini_cart_details_action } from "./mini-cart-details-action";

export interface ICartLineItemReducer {
    data: CartLineItemMiniDetails[],
};

export const initialMiniCartDetailsSelectorState: ICartLineItemReducer = {
    data: []
}

const _miniCartDetailReducer = createReducer(
    initialMiniCartDetailsSelectorState,
    on(set_mini_cart_details_action, (state, props) => { return { ...state, ...props } }),
    on(remove_item_from_mini_cart_action, (state, props) => {
        const tempCartItems = state.data.filter(item => item.identifier != props.identifier);
        return { ...state, data: tempCartItems, ...props }
    })
);

export function miniCartDetailReducer(state, action) {
    return _miniCartDetailReducer(state, action);
}
